import { LitElement, html, css } from 'lit';

class SearchAutocomplete extends LitElement {
    static properties = {
        resultsAreaSelector: { type: String, attribute: 'results-area-selector' },
        resultsAreaElement: { type: Object, state: true },
        query: { type: String, attribute: 'query' },
        results: { type: Array, state: true },
        resultsTotal: {type: Number, state: true},
        resultsOffset: {type: Number, state: true},
        currentPage: {type: Number, attribute: 'page'},
        totalPages: {type: Number, state: true},
        sortingMode: { type: String, attribute: 'order-by'},
        adultContent: {type: Number,},
        furryContent: {type: Number,},
        category: {type: String,},
        test: {type: Boolean,
            hasChanged(newVal, oldVal) {
                return newVal !== oldVal;
            },
            converter: {
                fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1') {
                        return true;
                    }
                    return false;
                }
            }
        },
        showAdult: {type: Boolean,
            hasChanged(newVal, oldVal) {
                return newVal !== oldVal;
            },
            converter: {
                fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1' ) {
                        return true;
                    }
                    return false;
                }
            }
        },
        showFurry: {
            type: Boolean,
            hasChanged(newVal, oldVal) {
                return newVal !== oldVal;
            },
            converter: {
                fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1' ) {
                        return true;
                    }
                    return false;
                }
            }
        },
        showCategory: {
            type: Boolean,
            hasChanged(newVal, oldVal) {
                return newVal !== oldVal;
            },
            converter: {
                fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1') {
                        return true;
                    }
                    return false;
                }
            }
        },
        showCollectionButton: {
            type: Boolean,
            hasChanged(newVal, oldVal) {
                return newVal !== oldVal;
            },
            converter: {
                fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1') {
                        return true;
                    }
                    return false;
                }
            }
        },
    };

    constructor() {
        super();
        this.resultsAreaSelector = 'results';
        this.query = '';
        this.results = [];
        this.resultsTotal = 0;
        this.resultsOffset = 0;
        this.currentPage = 1;
        this.totalPages = 1;
        this.timeoutId = null;
        this.adultContent = 0;
        this.furryContent = 0;
        this.category = '';
        this.sortingMode = '-last_file_date';
        this.showFurry = false;
        this.showAdult = false;
        this.showCategory = false;
        this.showCollectionButton = false;
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('popstate', this.popHistoryState.bind(this));
        this.resultsAreaElement = document.querySelector(this.resultsAreaSelector);
        this.fetchSuggestions(this.query);
    }

    static styles = css`
        input {
            background-color: var(--input-bg-color-lighter,#222222);
            color: var(--input-color-lighter,#A89368);
            height: 100%;
            width: 100%;
            border: 0;
            font-size: 1.2em;
            border-radius: 0.2em;
            
        }

        .search-row--horizontal {
            flex-direction: row;
            align-items: center;
            justify-content: right;
            flex-shrink: 2;
        }

        .search-row {
            display: flex;
            flex-direction: column;
            gap: 1em;
            margin-top: 0.5em;
            margin-bottom: 0.5em;
            width: 100%;
        }

        .search-options-selected {
            display: flex;
            flex-grow: 2;
            flex-flow: wrap;
            width: 100%;
            min-height: 60px;
            background-color: var(--input-bg-color,#222222);
            border-radius: 0.2em;
            box-shadow: rgba(0, 0, 0, 0.75) 0px 0px 5px 0px;
        }

        .search-options-selected p {
            margin-left: 1em;
            margin-right: 1em;
            color: #605E5B;
        }

        @media only screen and (min-width: 920px) {
            .search-row {
                flex-direction: row;
            }
        }
        
        .search-container {
            display: flex;
            flex-direction: row;
            flex-grow: 2;
            align-items: center;
            background-color: var(--input-bg-color-lighter,#222222);
            color: var(--input-color-lighter,#A89368);
            border: 1px solid var(--button-bg-color-hover,#4E432E);
            border-radius: 0.2em;
            font-size: 1.2em;
            padding: 8px 12px;
        }
    `;

    render() {
        return html`
            <div class="search-row">
                <div class="search-options-selected">
                    <p>You are using the new experimental site search. Please let us know what you think by posting in the #bugs-and-features channel on our <a href="https://discord.gg/T2DBVzH">Discord</a>.</p>
                </div>
                <div class="search-row search-row--horizontal">
                    ${this.showCategory ? html`<category-select-element title="Category" @categorychanged=${this._changeCategory}></category-select-element>` : ``}
                    ${this.showAdult ? html`<toggle-switch-multi-element identifier="nsfw" title="18+" toggleState="${this.adultContent}" @toggleswitched="${this._toggleSwitchCheck}"></toggle-switch-multi-element>` : ``}
                    ${this.showFurry ? html`<toggle-switch-multi-element identifier="furry" title="Furry" toggleState="${this.furryContent}" @toggleswitched="${this._toggleSwitchCheck}"></toggle-switch-multi-element>` : ``}
                </div>
            </div>
            
            <div class="search-options">
                <div class="search-row">
                    <div class="search-container">
                        <input type="text" .value=${this.query} @input=${this.onInput} placeholder="Search for projects..."/>
                    </div>
                    <project-order-element @orderchange="${this._changeOrderBy}" orderBy="${this.sortingMode}"></project-order-element>
                </div>
            </div>
        `;
    }

    _toggleSwitchCheck(e) {
        if (e.detail.identifier == 'nsfw') {
            this.adultContent = e.detail.toggleState;
        } else if (e.detail.identifier == 'furry') {
            this.furryContent = e.detail.toggleState;
        }
        this.fetchSuggestions(this.query);
    }
    _changeOrderBy(event) {
        this.currentPage = 1;
        this.sortingMode = event.detail.orderBy;
        this.fetchSuggestions(this.query);
    }

    _changeCategory(event) {
        this.currentPage = 1;
        this.category = event.detail.category;
        this.fetchSuggestions(this.query);
    }

    // Pagination event handlers
    _pageChanged = (event) => {
        if (event.detail.page !== this.currentPage && event.detail.page >= 1 && event.detail.page <= this.totalPages) {
            this.currentPage = event.detail.page ?? 1;

            this.fetchSuggestions(this.query);
        }
    }

    onInput(event) {
        const value = event.target.value;
        this.query = value;

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        this.currentPage = 1;

        if (value.length >= 3) {
            this.timeoutId = setTimeout(() => {
                this.fetchSuggestions(value);
            }, 300);
        } else {
            if (!value) {
                this.fetchSuggestions('');
            }
        }
    }

    pushHistoryState() {
        const url = new URL(window.location);
        if (this.query.length > 0) {
            url.searchParams.set('query', this.query);
        }
        if (this.category) {
        url.searchParams.set('category', this.category);
        }
        url.searchParams.set('page', this.currentPage);
        url.searchParams.set('order_by', this.sortingMode);
        let state = {
            query: this.query,
            category: this.category,
            currentPage: this.currentPage,
            sortingMode: this.sortingMode,
        };
        window.history.pushState(state, '', url);
    }

    popHistoryState(event) {
        const state = event.state;
        if (state) {
            this.query = state.query ?? '';
            this.category = state.category ?? '';
            this.currentPage = state.currentPage ?? 1;
            this.sortingMode = state.sortingMode ?? '-last_file_date';
            this.fetchSuggestions(this.query, true);
        }
    }

    fetchSuggestions(query, ignoreHistory = false) {
        // Push the current state to the history stack
        // We give the option to ignore this for when we're restoring state FROM the history stack
        if (!ignoreHistory) {
            this.pushHistoryState();
        }

        let testQueryUrlPart = '';
        let furryUrlPart = '&furry=';
        let nsfwUrlPart = '&nsfw=';
        if (this.furryContent === 0) {
            furryUrlPart += 'false';
        } else if (this.furryContent === 2) {
            furryUrlPart += 'true';
        }

        if (this.adultContent === 0) {
            nsfwUrlPart += 'false';
        } else if (this.adultContent === 2) {
            nsfwUrlPart += 'true';
        }

        if (this.test) {
            testQueryUrlPart = '&test_query=true';
        }

        this.resultsAreaElement.setAttribute('is-loading', 'true');
        const xhr = new XMLHttpRequest();
        xhr.open('GET', `/api/search/?q=${encodeURIComponent(query)}&category=${this.category}&order_by=${this.sortingMode}&page=${this.currentPage}${furryUrlPart}${nsfwUrlPart}${testQueryUrlPart}`);
        xhr.responseType = 'json';

        xhr.onload = () => {
            if (xhr.status === 200) {
                const data = xhr.response;
                this.results = data.results?.latest_results || [];
                this.totalPages = data.results.num_pages || 0;
                this.resultsTotal = data.results.item_count || 0;
                this.resultsAreaElement.innerHTML = '';
                this.resultsAreaElement.setAttribute('is-loading', 'false');
                this.constructResultElements(this.results);
                this.constructPaginationElement();
            } else {
                this.renderErrorMessage('Unexpected server response: ' + xhr.statusText);
                console.error('Unexpected server response: ', xhr.statusText);
            }
        };

        xhr.onerror = () => {
            console.error('Network error occurred while fetching results.');
            renderErrorMessage('Network error occurred while fetching results.');
        };

        xhr.send();
    }

    get _slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot[name="results"]');
        return slot.assignedElements({flatten: true});
    }

    constructResultElements(results) {
        this.resultsAreaElement.innerHTML = '';

        results.map((result) => {
            const resultElement = document.createElement('project-element');
            resultElement.setAttribute('project_id', result.uuid);
            resultElement.setAttribute('project_name', result.title);
            resultElement.setAttribute('project_thumb', result.item_thumb);
            resultElement.setAttribute('user_id', result.author_id);
            resultElement.setAttribute('username', result.username);
            resultElement.setAttribute('profilename', result.display_name);
            resultElement.setAttribute('staff', result?.is_staff ?? false);
            resultElement.setAttribute('patron', result?.paid_supporter ?? false);
            resultElement.setAttribute('verified', result?.verified_uploader ?? false);
            resultElement.setAttribute('nsfw', result.adult_content);
            resultElement.setAttribute('furry', result.furry_content);
            resultElement.setAttribute('showCollectionButton', this.showCollectionButton);
            resultElement.setAttribute('slot', 'results');
            resultElement.classList.add('entry--open');
            this.resultsAreaElement.appendChild(resultElement);
        });
    }

    constructPaginationElement() {
        let paginationElementBottom = this.resultsAreaElement.querySelector('#pagination_bottom');
        let paginationElementTop = this.resultsAreaElement.querySelector('#pagination_top');
        if (!paginationElementBottom) {
            paginationElementBottom = document.createElement('pagination-element');
            paginationElementBottom.setAttribute('slot', 'pagination_bottom');
            paginationElementBottom.classList.add('pagination_bottom');
            paginationElementBottom.addEventListener('pagechange', this._pageChanged);
            this.resultsAreaElement.appendChild(paginationElementBottom);
        }
        if (!paginationElementTop) {
            paginationElementTop = paginationElementBottom.cloneNode(true);
            paginationElementTop.addEventListener('pagechange', this._pageChanged);
            paginationElementTop.setAttribute('slot', 'pagination_top');
            paginationElementTop.classList.add('pagination_top');
            this.resultsAreaElement.appendChild(paginationElementTop);
        }
        paginationElementBottom.setAttribute('totalPages', this.totalPages);
        paginationElementBottom.setAttribute('page', this.currentPage);
        paginationElementTop.setAttribute('totalPages', this.totalPages);
        paginationElementTop.setAttribute('page', this.currentPage);
    }

    renderErrorMessage(message) {
        this.resultsAreaElement.innerHTML = '';
        this.resultsAreaElement.setAttribute('error-message', message);
        this.resultsAreaElement.setAttribute('is-loading', 'false');
    }

}

window.customElements.define('search-element', SearchAutocomplete);